/*
  OKCA.search: autocompletado de la compra asistida (06-10-2026).
  JS vanilla, sin dependencias, sintaxis ES5.
  ⚠️ Los items también traen `real` y `marca`: aquí NO se leen, ni se buscan, ni se pintan.
  Solo se usa `t` (título), más _code, _ref, u, img, ty ya derivados de él.
*/
(function () {
  'use strict';
  window.OKCA = window.OKCA || {};
  if (window.OKCA.search) return;

  var uid = 0;

  // CSS inyectado una sola vez
  function injectCss() {
    if (document.getElementById('okca-search-css')) return;
    var s = document.createElement('style');
    s.id = 'okca-search-css';
    s.textContent =
      '.okca-s{position:absolute;left:0;right:0;top:calc(100% + 6px);z-index:20;margin:0;padding:6px;list-style:none;' +
      'background:#fff;border:1px solid #E4DACB;border-radius:12px;box-shadow:0 12px 32px rgba(28,26,24,.12);' +
      'max-height:60vh;overflow-y:auto;font-family:inherit;opacity:0;transform:translateY(4px);' +
      'transition:opacity 160ms cubic-bezier(.23,1,.32,1),transform 160ms cubic-bezier(.23,1,.32,1)}' +
      '.okca-s[hidden]{display:none}' +
      '.okca-s.okca-s--on{opacity:1;transform:none}' +
      '.okca-s__o{display:flex;align-items:center;gap:12px;min-height:48px;padding:6px 10px;border-radius:8px;cursor:pointer;color:#1C1A18}' +
      '.okca-s__o[aria-selected="true"],.okca-s__o:hover{background:#F6EFE3}' +
      '.okca-s__th{flex:0 0 36px;width:36px;height:36px;border-radius:8px;background:#F6EFE3;object-fit:cover;display:block;overflow:hidden}' +
      '.okca-s__code{flex:0 0 auto;font-family:"Cormorant Garamond",Georgia,serif;font-weight:600;font-size:18px;line-height:1.1;color:#1C1A18}' +
      '.okca-s__ref{flex:1 1 auto;min-width:0;font-size:13px;line-height:1.3;color:#6B635A}' +
      '.okca-s__o mark{background:none;color:#1C1A18;font-weight:700}' +
      '.okca-s__none{padding:14px 12px;font-size:13px;color:#6B635A}' +
      '.okca-s__hint{padding:8px 12px 6px;font-size:11px;color:#B89860;letter-spacing:.04em}' +
      '@media (prefers-reduced-motion:reduce){.okca-s{transition:none;transform:none}}';
    document.head.appendChild(s);
  }

  // Quita acentos y pasa a minúsculas (1 carácter -> 1 carácter, para poder mapear posiciones)
  function norm(str) {
    str = String(str == null ? '' : str);
    var out = '';
    for (var i = 0; i < str.length; i++) {
      var c = str.charAt(i);
      var n = c.normalize ? c.normalize('NFD').replace(/[̀-ͯ]/g, '') : c;
      out += (n.length ? n.charAt(0) : c).toLowerCase();
    }
    return out;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Resalta las palabras de la consulta dentro de text (escapado)
  function highlight(text, words) {
    text = String(text == null ? '' : text);
    var n = norm(text), mask = [], i, j, p;
    for (i = 0; i < text.length; i++) mask.push(0);
    for (i = 0; i < words.length; i++) {
      if (!words[i]) continue;
      p = n.indexOf(words[i]);
      while (p > -1) {
        for (j = p; j < p + words[i].length; j++) mask[j] = 1;
        p = n.indexOf(words[i], p + words[i].length);
      }
    }
    var out = '', open = false;
    for (i = 0; i < text.length; i++) {
      if (mask[i] && !open) { out += '<mark>'; open = true; }
      if (!mask[i] && open) { out += '</mark>'; open = false; }
      out += esc(text.charAt(i));
    }
    return out + (open ? '</mark>' : '');
  }

  // Puntuación de un item (solo sobre `t`). 0 = no coincide
  function score(it, words, q) {
    var t = norm(it && it.t), code = norm(it && it._code), i, w, s = 0, best;
    if (!t) return 0;
    var tw = t.split(/[^a-z0-9]+/);
    for (i = 0; i < words.length; i++) {
      w = words[i];
      if (t.indexOf(w) < 0) return 0;
    }
    if (code && code === q) s = 1000;
    else if (code && code.indexOf(q) === 0) s = 800;
    else {
      best = 0;
      for (i = 0; i < words.length; i++) {
        var starts = false, k;
        for (k = 0; k < tw.length; k++) if (tw[k].indexOf(words[i]) === 0) { starts = true; break; }
        best += starts ? 2 : 1;
      }
      s = 100 + best * 10 - (best < words.length * 2 ? 0 : 0);
      if (t.indexOf(q) > -1) s += 5;
    }
    return s;
  }

  function attach(opts) {
    opts = opts || {};
    var input = opts.input;
    if (!input || input.getAttribute('data-okca-s')) return;
    input.setAttribute('data-okca-s', '1');
    injectCss();

    var max = opts.max || 6;
    var labels = opts.labels || {};
    var noRes = labels.noResults || 'Sin coincidencias';
    var hint = labels.hint || '';
    var id = 'okca-s-' + (++uid);

    // El wrapper es el contenedor posicionado del input
    var wrap = input.closest ? (input.closest('label') || input.parentNode) : input.parentNode;
    try {
      if (window.getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
    } catch (e) {}

    var list = document.createElement('ul');
    list.className = 'okca-s';
    list.id = id;
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    wrap.appendChild(list);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', id);

    var shown = [], active = -1, timer = null, openState = false;

    function setActive(i) {
      var opts2 = list.querySelectorAll('[role="option"]');
      active = i;
      for (var k = 0; k < opts2.length; k++) opts2[k].setAttribute('aria-selected', k === i ? 'true' : 'false');
      if (i >= 0 && opts2[i]) {
        input.setAttribute('aria-activedescendant', opts2[i].id);
        if (opts2[i].scrollIntoView) {
          var o = opts2[i], top = o.offsetTop, bot = top + o.offsetHeight;
          if (top < list.scrollTop) list.scrollTop = top - 6;
          else if (bot > list.scrollTop + list.clientHeight) list.scrollTop = bot - list.clientHeight + 6;
        }
      } else input.removeAttribute('aria-activedescendant');
    }

    function close() {
      openState = false;
      active = -1;
      shown = [];
      list.hidden = true;
      list.className = 'okca-s';
      list.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function open() {
      var was = openState;
      openState = true;
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      if (!was) {
        // fuerza reflow para que la transición arranque
        void list.offsetWidth;
        list.className = 'okca-s okca-s--on';
      }
    }

    function pick(i) {
      var it = shown[i];
      if (!it) return;
      close();
      if (opts.onPick) opts.onPick(it);
    }

    function render(q) {
      var items = [];
      try { items = (opts.items && opts.items()) || []; } catch (e) { items = []; }
      if (!items.length) { close(); return; }
      var qn = norm(q).replace(/^\s+|\s+$/g, '');
      var words = qn.split(/\s+/);
      var res = [], i, s;
      for (i = 0; i < items.length; i++) {
        s = score(items[i], words, qn);
        if (s > 0) res.push({ it: items[i], s: s, i: i });
      }
      res.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
      res = res.slice(0, max);

      var html = '';
      shown = [];
      if (!res.length) {
        html = '<li class="okca-s__none" role="presentation">' + esc(noRes) + '</li>';
      } else {
        for (i = 0; i < res.length; i++) {
          var it = res[i].it;
          shown.push(it);
          var thumb = it.img
            ? '<img class="okca-s__th" src="' + esc(it.img) + '" alt="" width="36" height="36" loading="lazy">'
            : '<span class="okca-s__th" aria-hidden="true"></span>';
          var code = it._code
            ? '<span class="okca-s__code">' + highlight(it._code, words) + '</span>' : '';
          var ref = it._code ? it._ref : (it._ref || it.t);
          html += '<li class="okca-s__o" role="option" aria-selected="false" id="' + id + '-' + i +
            '" data-i="' + i + '">' + thumb + code +
            '<span class="okca-s__ref">' + highlight(ref, words) + '</span></li>';
        }
        if (hint) html += '<li class="okca-s__hint" role="presentation">' + esc(hint) + '</li>';
      }
      list.innerHTML = html;
      active = -1;
      input.removeAttribute('aria-activedescendant');
      open();
    }

    function run() {
      var q = input.value || '';
      if (opts.onQuery) opts.onQuery(q);
      if (!q.replace(/\s+/g, '')) close();
      else render(q);
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 80);
    });

    input.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowDown' || k === 'ArrowUp') {
        if (!openState || !shown.length) return;
        e.preventDefault();
        var n = shown.length;
        setActive(k === 'ArrowDown' ? (active + 1) % n : (active <= 0 ? n - 1 : active - 1));
      } else if (k === 'Enter') {
        if (openState && active > -1) { e.preventDefault(); pick(active); }
        else if (openState) close();
      } else if (k === 'Escape') {
        if (openState) { e.preventDefault(); close(); }
      }
    });

    input.addEventListener('blur', function () { close(); });

    // mousedown con preventDefault: el input no pierde el foco y el toque llega al click
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('click', function (e) {
      var el = e.target;
      while (el && el !== list && !(el.getAttribute && el.getAttribute('role') === 'option')) el = el.parentNode;
      if (el && el !== list) pick(parseInt(el.getAttribute('data-i'), 10));
    });
  }

  window.OKCA.search = { attach: attach };
})();
